import { render, staticRenderFns } from "./SlCategory.vue?vue&type=template&id=233644f2&scoped=true&"
import script from "./SlCategory.vue?vue&type=script&lang=js&"
export * from "./SlCategory.vue?vue&type=script&lang=js&"
import style0 from "./SlCategory.vue?vue&type=style&index=0&id=233644f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233644f2",
  null
  
)

export default component.exports